import noodleApiClient, { ApiDefinition } from '@noodleApi';
import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/credit-reports-b2b/{creditReportId}/response']['POST'];

type Input = ThisApi['params'] & ThisApi['body'];
type Output = ThisApi['response'];

const pullCreditReportData = async ({creditReportId, ...body}: Input): Promise<Output> => {
  const path = buildPath<ThisApi>('/credit-reports-b2b/{creditReportId}/response', { creditReportId });
  const response = await noodleApiClient.post(path, body);
  return response.data;
};

export default pullCreditReportData;
